export interface StoreProduct {
  id: number;
  productID: string;
  productName: string;
  productPrice: number;
  productReviews: string;
  frontImg: string;
  backImg?: string;
  productDiscount?: number;
}

export interface StoreMenuData {
  grains: string;
  rice: string;
  pulses: string;
  spicesandNuts: string;
  flourandMasalas: string;
  oilingredients: string;
  AmericaFlag: string;
  IndiaFlag: string;
  ReadyForCook: string,
  DiaryProducts: string,
  otherIngredients: string,
  HealthDrinks: string,
  Biscuit: string,
  snacks: string,
  Tea_and_coffee: string,
  oralcare: string,
  bodycare: string,
  haircare: string,
  facecare: string,
  hairRemoval: string,
  babycare: string,
  feminineHygiene: string,
  laundryDetergent: string,
  utensilscleaning: string,
  cleaningTool: string,
  poojaDevotional: string,
  stationary: string,
  miscellaneous: string,
  insertRepellent: string,
  householdCleaning: string

}


export interface StoreProduct {
  id: number;
  productID: string;
  productName: string;
  productPrice: number;
  productReviews: string;
  frontImg: string;
  backImg?: string;
}


export interface IStockItem {
  BTBSellingRate: number;
  BTCSellingRate: number;
  Barcode: string;
  Comments: string;
  CopponName: string;
  Dis_Mode: string;
  Discount_PV: number;
  FilePath: string;
  From_QV: number;
  Gsmcode: string;
  Hsncode: string;
  Mrprate: number;
  To_QV: number;
  assignId: number;
  batchno: string;
  category: string;
  coinchange: number;
  effectdate: string; // You can also use Date if you parse it
  itemid: number;
  itemname: string;
  minsalqty: number;
  stock: number;
  subcategory: string;
  subcategoryname: string;
  sudexo: string | null;
  taxid: number;
  taxname: string;
  taxper: number;
  unitOfMeasure: string;
  itemdescription:string;
}

export const defaultStockItem: IStockItem = {
  BTBSellingRate: 0,
  BTCSellingRate: 0,
  Barcode: "",
  Comments: "",
  CopponName: "",
  Dis_Mode: "",
  Discount_PV: 0,
  FilePath: "",
  From_QV: 0,
  Gsmcode: "",
  Hsncode: "",
  Mrprate: 0,
  To_QV: 0,
  assignId: 0,
  batchno: "",
  category: "",
  coinchange: 0,
  effectdate: "", // or new Date().toISOString() if you want current date string
  itemid: 0,
  itemname: "",
  minsalqty: 0,
  stock: 0,
  subcategory: "",
  subcategoryname: "",
  sudexo: null,
  taxid: 0,
  taxname: "",
  taxper: 0,
  unitOfMeasure: "",
  itemdescription:""

};



export interface ProductImageZoomProps {
  image: string;
}

export interface ProductCardProps {
  image: string;
  name: string;
  price: number;
  mrp: number;

}


export interface LatestProductItem {
  frontImg: string;
  productName: string;
  productPrice: number;
}



export interface ProductDetails {
  productID: number;
  productName: string;
  productPrice: number;
  frontImg: string;
  productReviews: string;
  quantity?: number;
}